import React from "react";
import { Button, Modal } from "@themesberg/react-bootstrap";

export default ({
  show,
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "primary",
  onCancel,
  onConfirm,
  processing = false
}) => (
  <Modal as={Modal.Dialog} centered show={show} onHide={processing ? undefined : onCancel}>
    <Modal.Header>
      <Modal.Title className="h6">{title}</Modal.Title>
      <Button variant="close" aria-label="Close" onClick={onCancel} disabled={processing} />
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">{body}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-gray-600" onClick={onCancel} disabled={processing}>
        {cancelLabel}
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm} disabled={processing}>
        {processing ? "Please wait..." : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);
